<script>
export default {
  props: {
    showOnDesktop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      windowTop: 0,
    }
  },
  computed: {
    showButton() {
      return this.windowTop > window.innerHeight
    },
    class() {
      return this.showOnDesktop
        ? this.$style.showDesktop
        : this.$style.showMobile
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    goUp() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    },
    onScroll(e) {
      this.windowTop =
        window.top.scrollY /* or: e.target.documentElement.scrollTop */
    },
  },
}
</script>

<template>
  <v-fab-transition>
    <v-btn
      v-show="showButton"
      fab
      fixed
      bottom
      right
      small
      primary
      title="Scroll to top"
      @click="goUp"
    >
      <v-icon>north</v-icon>
    </v-btn>
  </v-fab-transition>
</template>

<style lang="scss" module>
@import '@design';

.showDesktop {
  @media screen and (max-width: $screen-md) {
    display: none;
  }
}

.showMobile {
  @media screen and (min-width: $screen-md) {
    display: none;
  }
}
</style>
